import { Component } from "solid-js";
import logo from "../../../assets/brand/logo-48.png";
import { A } from "@solidjs/router";
import { createLocalI18n, Locale } from "../../../i18n.js";

const i18nDefault = {
  discordServer: "Discord Server",
  services: "Services",
  resources: "Resources",
  soon: "Soon",
  resourcesLink: {
    discord: "Discord Server",
    documentation: "Documentation",
  },
  legal: "Legal",
  legalLink: {
    tos: "Terms of Service",
    privacy: "Privacy Policy",
    cookie: "Cookie Policy",
  },
  disclaimer:
    "This service is not affiliated with Discord, Steam, or any other platform.",
  lastBuild: "Last Build",
};

const i18nLocalDicts: Record<Locale, typeof i18nDefault> = {
  [Locale.US]: i18nDefault,
  [Locale.FR]: {
    discordServer: "Serveur Discord",
    services: "Services",
    resources: "Ressources",
    legal: "Légal",
    soon: "Bientôt",
    resourcesLink: {
      discord: "Serveur Discord",
      documentation: "Documentation",
    },
    legalLink: {
      tos: "Conditions d'utilisation",
      privacy: "Politique de confidentialité",
      cookie: "Politique de cookies",
    },
    disclaimer:
      "Ce service n'est pas affilié à Discord, Steam ou toute autre plateforme.",
    lastBuild: "Dernière Compilation",
  },
};

const { localChained } = createLocalI18n(i18nDefault, i18nLocalDicts);

const Footer: Component = () => {
  // @ts-ignore
  const lastBuildDate = new Date(__BUILD_DATE__).toLocaleString() || "Unknown";

  return (
    <>
      <div class="bg-base-200 text-base-content border-base-300 border-t-2">
        <footer class="footer sm:footer-horizontal bg-base-200 text-base-content justify-around p-10 max-w-screen-2xl mx-auto">
          <nav>
            <h6 class="footer-title">{localChained.services()}</h6>
            <a
              class="link text-base-content/60 link-hover"
              href="http://gmod-integration.com"
            >
              Gmod Integration
            </a>
          </nav>
          <nav>
            <h6 class="footer-title">{localChained.resources()}</h6>
            <a
              class="link text-base-content/60 link-hover"
              href="https://docs.gmod-integration.com"
            >
              {localChained.resourcesLink.documentation()}
            </a>
            <a
              class="link text-base-content/60 link-hover"
              href="https://discord.gg/mabsRHCjSs"
            >
              {localChained.discordServer()}
            </a>
          </nav>
          <nav>
            <h6 class="footer-title">{localChained.legal()}</h6>
            <p
              class="text-gray-600 line-through link link-hover"
              // href="/legals/terms-of-use"
            >
              {`${localChained.legalLink.tos()} (${localChained.soon()})`}
            </p>
            <p
              class="text-gray-600 line-through link link-hover"
              // href="/legals/privacy-policy"
            >
              {`${localChained.legalLink.privacy()} (${localChained.soon()})`}
            </p>
            <p
              class="text-gray-600 line-through link link-hover"
              // href="/legals/cookie-policy"
            >
              {`${localChained.legalLink.cookie()} (${localChained.soon()})`}
            </p>
          </nav>
        </footer>

        <footer class="footer bg-base-200 text-base-content/60 border-base-300 border-t-2 px-10 py-4 ">
          <div class="flex h-full w-full max-w-screen-2xl mx-auto">
            <div class="flex gap-2 items-center">
              <img src={logo} alt="logo" width="40" height="40" />
              <div class="flex flex-col">
                <h3 class="text-base-content font-bold">Discord Integration</h3>
                <p>{localChained.disclaimer()}</p>
              </div>
            </div>
            <div class="flex-grow h-full flex items-center justify-center" />
            <div class="flex text-right text-base-content/60 h-full items-center">
              {localChained.lastBuild() + ": " + lastBuildDate}
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Footer;
